export default "__VITE_ASSET__CrFb9ynu__"